import { TOGGLE_ROLE_SECTION, PIN_PARTICIPATION_ELEMENT, ROLES_SET_CLICKED_ELEMENT } from './constants'

export function toggleRoleSection(module, id, blockKey, customData) {
    return {
        type: TOGGLE_ROLE_SECTION,
        data: {
            module,
            id,
            blockKey,
            customData,
        },
    }
}

export function pinParticipationElement(module, id, blockKey, customData) {
    return {
        type: PIN_PARTICIPATION_ELEMENT,
        data: {
            module,
            id,
            blockKey,
            customData,
        },
    }
}

export function roleSetClickedElement(module, id, blockKey, customData) {
    return {
        type: ROLES_SET_CLICKED_ELEMENT,
        data: {
            module,
            id,
            blockKey,
            customData,
        },
    }
}
